// Get elements
const popupOverlay = document.getElementById('popupChartOverlay');
const showPopupBtn = document.getElementById('popup-trigger-chart');
const closePopupBtn = document.getElementById('closePopupChartBtn');

// Show popup
showPopupBtn.addEventListener('click', () => {
  popupOverlay.style.display = 'flex';
  document.body.style.overflow = 'hidden'; // Disable body scroll
});

// Close popup
closePopupBtn.addEventListener('click', () => {
  popupOverlay.style.display = 'none';
  document.body.style.overflow = ''; // Re-enable body scroll
});

// Close popup if clicked outside the content
popupOverlay.addEventListener('click', (event) => {
  if (event.target === popupOverlay) {
    popupOverlay.style.display = 'none';
    document.body.style.overflow = ''; // Re-enable body scroll
  }
});